export default "__VITE_ASSET__DPHO3J0k__"